/* Brilinton geo size restriction
 * v58: moved from footer-group custom-liquid into an owned asset.
 * Purpose preserved: hide 41/44/45mm links/options outside the US unless Shopify/country check allows them.
 */
(function () {
  var restrictedSizes = ['41mm', '44mm', '45mm'];
  var allowedCountry = 'US';
  var styleId = 'geo-restricted-styles';

  function injectDefaultRestrictions() {
    if (document.getElementById(styleId)) return;

    try {
      var style = document.createElement('style');
      style.id = styleId;
      var cssRules = '';

      restrictedSizes.forEach(function (size) {
        cssRules += 'input[type="radio"][value="' + size + '"] { display: none !important; } ';
        cssRules += 'input[type="radio"][value="' + size + '"] + label { display: none !important; } ';

        var sizeNumber = size.replace('mm', '');
        cssRules += '.spec-case .size_' + sizeNumber + ' { display: none !important; } ';
        cssRules += 'a[href*="/collections/apple-watch-' + size + '"] { display: none !important; } ';
      });

      style.innerHTML = cssRules;
      document.head.appendChild(style);
    } catch (error) {
      console.error('Error applying default restrictions', error);
    }
  }

  function revealForUS() {
    var styleTag = document.getElementById(styleId);
    if (styleTag) styleTag.remove();
  }

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function cleanupForNonUS() {
    onReady(function () {
      restrictedSizes.forEach(function (size) {
        document.querySelectorAll('a[href*="' + size + '"]').forEach(function (link) {
          var parentListItem = link.closest('li');
          if (parentListItem) {
            parentListItem.style.display = 'none';
          } else {
            link.style.display = 'none';
          }
        });
      });

      window.setTimeout(function () {
        var allRadioInputs = document.querySelectorAll('input[type="radio"][name^="Size"]');
        var currentSelectionRestricted = false;

        allRadioInputs.forEach(function (input) {
          if (input.checked && restrictedSizes.indexOf(input.value) !== -1) {
            currentSelectionRestricted = true;
            input.checked = false;
          }
        });

        if (!currentSelectionRestricted) return;

        for (var i = 0; i < allRadioInputs.length; i += 1) {
          if (restrictedSizes.indexOf(allRadioInputs[i].value) === -1) {
            allRadioInputs[i].click();
            var legendSpan = document.querySelector('[data-selected-value]');
            if (legendSpan) legendSpan.innerText = allRadioInputs[i].value;
            break;
          }
        }
      }, 500);
    });
  }

  injectDefaultRestrictions();

  if (window.Shopify && window.Shopify.country) {
    if (window.Shopify.country === allowedCountry) revealForUS();
    else cleanupForNonUS();
    return;
  }

  fetch('https://get.geojs.io/v1/ip/country.json')
    .then(function (response) { return response.json(); })
    .then(function (data) {
      if (data.country === allowedCountry) revealForUS();
      else cleanupForNonUS();
    })
    .catch(function (error) {
      console.error('Error fetching country:', error);
      revealForUS();
    });
})();
